var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalBlueCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 167,
    viewBox: "0 0 166 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 157C123.593 157 156.5 124.093 156.5 83.5C156.5 42.9071 123.593 10 83 10C42.4071 10 9.5 42.9071 9.5 83.5C9.5 124.093 42.4071 157 83 157Z",
    stroke: "#F3F2F2",
    strokeWidth: 18.5606
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9986 10C92.9795 9.99468 102.858 12.0153 112.035 15.9394C112.035 15.9394 122.429 20.4608 130.788 27.64C145.598 40.3142 154.766 58.3519 156.277 77.7856C157.787 97.2193 151.517 116.457 138.844 131.268C112.636 161.915 65.8486 165.538 35.2087 139.345C6.71449 114.957 1.58433 72.7794 22.0975 42.3549",
    stroke: "url(#paint0_linear_1284_64299)",
    strokeWidth: 18.5606
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3047 81.2725L69.638 99.8331L112.699 61.2271",
    stroke: "url(#paint1_linear_1284_64299)",
    strokeWidth: 5.19697
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1284_64299",
    x1: 20.5491,
    y1: 29.9882,
    x2: 145.835,
    y2: 137.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22B4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#1FAEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#179DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#0A82F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#006EF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1284_64299",
    x1: 82.8977,
    y1: 103.523,
    x2: 82.8977,
    y2: 59.2967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22B4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#21B1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1CA8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1498F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#0A82F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#006EF3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalBlueCheck);
export default __webpack_public_path__ + "static/media/modal-blue-check.919eee8f8c9e600ccdc561f5cdffe440.svg";
export { ForwardRef as ReactComponent };